export { Trans, useTranslation } from 'react-i18next';
export { getI18n, loadTenantOverrides } from './config';
export { I18nProvider } from './provider';
export { NAMESPACES, tenantNamespace } from './namespaces';
export type { Namespace } from './namespaces';
